var _rect, _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlockeduser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 67,
    rx: 11,
    fill: "url(#paint0_linear_4819_4017)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4819_4017)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.8948 41.1859V38.3743C37.8948 36.2448 36.3117 34.4659 34.2656 34.1559C33.5777 34.7702 32.6709 35.1422 31.6769 35.1422C30.6829 35.1422 29.776 34.7702 29.0882 34.1559C27.0421 34.4659 25.459 36.2448 25.459 38.3743V41.1859H37.8948Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.2657 34.1559C35.062 33.4429 35.5639 32.4081 35.5639 31.2552C35.5639 29.1082 33.8238 27.3681 31.677 27.3681C29.5301 27.3681 27.79 29.1082 27.79 31.2552C27.79 32.4081 28.2919 33.4429 29.0883 34.1559C29.7762 34.7702 30.6829 35.1422 31.677 35.1422C32.6709 35.1422 33.5778 34.7702 34.2657 34.1559Z",
    fill: "#FFDCD5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7902 31.2551C27.7902 29.1082 29.5302 27.3681 31.6771 27.3681C33.824 27.3681 35.564 29.1082 35.564 31.2551C35.564 32.4081 35.0622 33.4429 34.2658 34.1559C36.312 34.4659 37.895 36.2448 37.895 38.3743V41.1859H25.4592V38.3743C25.4592 36.2448 27.0423 34.4659 29.0884 34.1559C28.292 33.4429 27.7902 32.4081 27.7902 31.2551ZM46.6707 43.0674V29.7321C45.6903 30.2611 44.5683 30.5634 43.3748 30.5634C39.5421 30.5634 36.436 27.4553 36.436 23.6225C36.436 23.5082 36.438 23.3919 36.4438 23.2775H18.8906C17.6776 23.2775 16.6836 24.2716 16.6836 25.4846V43.0674C16.6836 44.2823 17.6757 45.2744 18.8906 45.2744H26.9996L31.6771 50.3164L36.3546 45.2745H44.4637C45.6767 45.2745 46.6707 44.2804 46.6707 43.0674Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7754 38.3743V41.1859C24.7754 41.5634 25.0814 41.8695 25.459 41.8695H37.8949C38.2724 41.8695 38.5784 41.5634 38.5784 41.1859V38.3743C38.5784 36.3399 37.3057 34.5327 35.4797 33.7872C35.9642 33.0619 36.2475 32.1911 36.2475 31.2551C36.2475 28.7349 34.1971 26.6846 31.677 26.6846C29.1568 26.6846 27.1064 28.7349 27.1064 31.2551C27.1064 32.1911 27.3897 33.0619 27.8742 33.7872C26.0482 34.5326 24.7754 36.3399 24.7754 38.3743ZM31.6769 28.0518C33.4432 28.0518 34.8802 29.4887 34.8802 31.2551C34.8802 33.0216 33.4432 34.4586 31.6769 34.4586C29.9105 34.4586 28.4736 33.0216 28.4736 31.2551C28.4736 29.4887 29.9105 28.0518 31.6769 28.0518ZM28.9069 34.8874C29.6761 35.4754 30.6362 35.8259 31.677 35.8259C32.7177 35.8259 33.6778 35.4755 34.447 34.8874C36.0415 35.2648 37.2113 36.7151 37.2113 38.3743V40.5023H26.1426V38.3743C26.1426 36.7151 27.3123 35.2648 28.9069 34.8874Z",
    fill: "url(#paint1_linear_4819_4017)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3748 16C39.5206 16 36.3258 18.8756 35.8221 22.594H18.8906C17.2967 22.594 16 23.8908 16 25.4847V31.2067C16 31.5842 16.306 31.8903 16.6836 31.8903C17.0611 31.8903 17.3672 31.5842 17.3672 31.2067V25.4847C17.3672 24.6446 18.0506 23.9612 18.8906 23.9612H35.7604C35.9382 28.0088 39.2853 31.247 43.3748 31.247C44.292 31.247 45.172 31.0841 45.9871 30.7859V43.0674C45.9871 43.9075 45.3038 44.5909 44.4638 44.5909H36.3547C36.1645 44.5909 35.9829 44.6701 35.8535 44.8096L31.6772 49.3113L27.5008 44.8096C27.3715 44.6701 27.1899 44.5909 26.9997 44.5909H18.8906C18.0506 44.5909 17.3672 43.9075 17.3672 43.0674V37.3473C17.3672 36.9699 17.0611 36.6637 16.6836 36.6637C16.306 36.6637 16 36.9699 16 37.3473V43.0674C16 44.6613 17.2967 45.9581 18.8906 45.9581H26.7014L31.1761 50.7813C31.3054 50.9208 31.487 51 31.6772 51C31.8674 51 32.049 50.9208 32.1783 50.7813L36.653 45.9581H44.4638C46.0577 45.9581 47.3544 44.6613 47.3544 43.0674V30.1235C49.539 28.7812 50.9991 26.3693 50.9991 23.6225C50.999 19.4194 47.5788 16 43.3748 16ZM43.3748 29.8798C39.9256 29.8798 37.1196 27.0728 37.1196 23.6225C37.1196 20.1733 39.9256 17.3672 43.3748 17.3672C46.825 17.3672 49.6319 20.1733 49.6319 23.6225C49.6319 27.0728 46.825 29.8798 43.3748 29.8798Z",
    fill: "url(#paint2_linear_4819_4017)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6836 34.9597C17.0611 34.9597 17.3672 34.6536 17.3672 34.2761V34.2742C17.3672 33.8967 17.0611 33.5916 16.6836 33.5916C16.306 33.5916 16 33.8986 16 34.2761C16 34.6537 16.306 34.9597 16.6836 34.9597Z",
    fill: "url(#paint3_linear_4819_4017)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5 17C39.9101 17 37 19.9101 37 23.5C37 27.0899 39.9101 30 43.5 30C47.0899 30 50 27.0899 50 23.5C50 19.9101 47.0899 17 43.5 17ZM43.5 18.8571C44.4462 18.8571 45.3251 19.1417 46.0591 19.6279L39.6279 26.0591C39.1417 25.3251 38.8571 24.4462 38.8571 23.5C38.8571 20.9358 40.9358 18.8571 43.5 18.8571ZM43.5 28.1429C42.5538 28.1429 41.6749 27.8582 40.9409 27.3721L47.3721 20.9409C47.8582 21.6749 48.1429 22.5538 48.1429 23.5C48.1429 26.0642 46.0642 28.1429 43.5 28.1429Z",
    fill: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.5351 58.0375L44.548 57.0752L44.5479 57.0749L45.5351 58.0375Z",
    fill: "#377DE2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4819_4017",
    x1: 33.5,
    y1: 0,
    x2: 33.5,
    y2: 67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.08
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4819_4017",
    x1: 31.6769,
    y1: 26.6846,
    x2: 31.6769,
    y2: 41.8695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4819_4017",
    x1: 33.4996,
    y1: 16,
    x2: 33.4996,
    y2: 51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4819_4017",
    x1: 16.6836,
    y1: 33.5916,
    x2: 16.6836,
    y2: 34.9597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4819_4017"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockeduser);
export default __webpack_public_path__ + "static/media/BLOCKEDUSER.5f2e4530d5e6dbcade0e4f3b6d8ab91b.svg";
export { ForwardRef as ReactComponent };